import { WordObject } from '../../interfaces/word-object/WordObject';
import { WORD_TYPES } from '../../enums/Enums';
import { DicLang } from '../../item/item-types';

export class Word {
    public id;
    public name: string;
    public word: string;
    public translation;
    public userID?: string;
    private wordType: string;
    private messageID: string;
    public wordLanguage: string;
    public plusRate: number = 0;
    public minusRate: number = 0;
    public liked: boolean;
    public disliked: boolean;
    public related: boolean;
    public wordData: WordObject;
    public wordID: string;
    public sourceLang: DicLang;
    public targetLang: DicLang
    // public hasProposition : boolean = false;
    public hasProposition: boolean;

    hasArtikel() {
        return false;
    }
    public static get possibleTypes() {
        return WORD_TYPES
    };

    constructor(word: WordObject) {
        if (word.plusRate) {
            this.plusRate = word.plusRate;
            this.id = word.id;
            this.wordID = word.wordID ?? "";
            this.minusRate = word.minusRate ?? 0;
        }
        if (word.userID)
            this.userID = word.userID;
        this.word = word.word ?? '';

        this.related = parseInt(word.related) == 1 ? true : false;
        this.translation = word.translation;

        if (word.hasProposition)
            this.hasProposition = true;
    }

    setUserID(userID: string) {
        this.userID = userID;
    }
    setWordType(wordType: string) {
        this.wordType = wordType;
    }
    setMessageID(messageID: string) {
        this.messageID = messageID;
    }
    setLanguage(languageCode: string) {
        this.wordLanguage = languageCode;
    }
}